import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <div className='ui container '>
      <br />
      <div className='ui two column grid stackable'>
        <div className='column'>
          <Link to='/'>
            <div className='ui red ribbon huge label'>
              HRAF Cross Cultural Concordance
            </div>
          </Link>
        </div>
        <div className='column'>
          <div className='ui orange right ribbon huge label'>
            <Link to='/about'>
              <div className='about-button'>About</div>
            </Link>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
}

export default Header;
